import { GTM_CUSTOM_EVENTS, GTMCustomEvent } from '@/features/gtm/internal/types/custom-events';

export function emitGTMEvent<E extends GTMCustomEvent>(name: E): void;
export function emitGTMEvent<E extends GTMCustomEvent, P extends object>(name: E, payload: P): void;

export function emitGTMEvent(name: GTMCustomEvent, payload?: object): void {
  if (typeof window === 'undefined') return;
  const eventName = GTM_CUSTOM_EVENTS[name];
  const dl = (window.dataLayer = window.dataLayer || []);
  dl.push({ event: eventName, ...(payload ?? {}) });
}
